// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"1f0f93c2","275":"1b486011","466":"24edc316","552":"7dbd207f","653":"f195dd1e","668":"b2c11ca9","837":"9611d97c","983":"62c69c6c"}[chunkId] + ".chunk.css";
};